export enum LeakCheckFormType {
    Custom = 0
}

export enum FieldType {
    Text = 0,
    Number = 1,
    Checkbox = 2,
    Select = 3,
    Radio = 4,
    TextArea = 5,
    Date = 6
}

export interface FieldOption {
    label: string;
}

export interface CustomField {
    id: string;
    label: string;
    type: FieldType;
    isRequired: boolean;
    defaultValue?: string;
    options: FieldOption[];
}

export interface CustomerInfoSection {
    name: boolean;
    address: boolean;
    city: boolean;
    state: boolean;
    zipCode: boolean;
    phone: boolean;
}

export interface TankCheckSection {
    size: boolean;
    serialNumber: boolean;
    customerOwned: boolean;
    customFields: CustomField[];
}

export interface PressureTestSection {
    testType: string;
    customFields: CustomField[];
}

export interface RegulatorCheckSection {
    type: boolean;
    serialNumber: boolean;
    customFields: CustomField[];
}

export interface CustomSection {
    id: string;
    name: string;
    order: number;
    multipleRows: boolean;
    fields: CustomField[];
}

export interface LeakCheckForm {
    id: string;
    name: string;
    type: LeakCheckFormType;
    isActive: boolean;
    createdDate: Date;
    lastModifiedDate: Date;
    customerInfo: CustomerInfoSection;
    tankCheck: TankCheckSection;
    pressureTests: PressureTestSection[];
    regulatorCheck: RegulatorCheckSection;
    customSections: CustomSection[];
}

// Serialized type just for the date fields
export type SerializedLeakCheckForm = Omit<LeakCheckForm, "createdDate" | "lastModifiedDate"> & {
    createdDate: string;
    lastModifiedDate: string;
};

export function deserializeLeakCheckForm(serialized: SerializedLeakCheckForm): LeakCheckForm {
    return {
        ...serialized,
        createdDate: new Date(serialized.createdDate),
        lastModifiedDate: new Date(serialized.lastModifiedDate)
    };
}

export function deserializeLeakCheckForms(serialized: SerializedLeakCheckForm[]): LeakCheckForm[] {
    return serialized.map(deserializeLeakCheckForm);
}